// Лайтбокс картинок элемента поверх открытого диалога.
//
// Портал в `document.body` обязателен: у `DialogContent` стоит `translate`, а
// transform создаёт containing block для `fixed`-потомков — вложенный лайтбокс
// схлопнулся бы до размеров диалога. Вторая половина рецепта — на стороне
// вызывающего диалога: `modal={!lightbox.isOpen}` (иначе Radix считает клики в
// лайтбоксе «снаружи» и закрывает диалог) плюс `opacity-0 pointer-events-none`
// на `DialogContent`, чтобы он не загораживал лайтбокс, но не терял состояние.

import { createPortal } from "react-dom";

import { MediaLightbox } from "~/shared/ui/media-lightbox";

interface ElementLightboxProps {
    /** Лента картинок по порядку — элемента библиотеки или его снимка в сообщении. */
    images: readonly string[];
    /** Подпись слайда — имя элемента. */
    caption: string;
    /** Индекс открытого слайда; `null` — лайтбокс закрыт. */
    index: number | null;
    onClose: () => void;
}

export function ElementLightbox({ images, caption, index, onClose }: ElementLightboxProps) {
    return createPortal(
        <MediaLightbox
            items={images.map((url) => ({ url, type: "image" as const, caption }))}
            initialIndex={index ?? 0}
            isOpen={index !== null}
            onClose={onClose}
        />,
        document.body,
    );
}
